import Vue from 'vue'
import App from './App.vue'

import router from './router'
import store from './store'

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import ElementUI from 'element-ui';
Vue.use(ElementUI);
import locale from 'element-ui/lib/locale/lang/ca'
import '@/assets/scss/element-theme.css';

require('@fortawesome/fontawesome-free/css/all.css')

require('@/assets/scss/app.scss')

// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
// Init plugin
Vue.use(Loading);

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
